import React from 'react';
import { getBrand } from '@/utils/getBrand';
import Logo from '@/components/Logo';
import GoToQuizButton from './GoToQuizButton';

const FooterSection = ({ funnelId = 28, showQuizButton = true }) => {
  const { brandName, brandSupportEmail } = getBrand();

  return (
    <footer
      className="w-full flex flex-col"
      style={{
        background: 'linear-gradient(180deg, #FFF8F5 0%, #FFEFEE 50%, #FFE7EB 100%)',
      }}
    >
      {showQuizButton && (
        <div className="flex flex-col items-center gap-8 md:gap-10 px-4 md:px-6 py-10 md:py-20 text-center border-b border-[#DFDFDF] pb-6 md:pb-10">
          <h2 className="text-[24px] md:text-[48px] font-semibold leading-[1.33em] md:leading-[1.17em] tracking-[-0.1px] text-[#333]">
            Your next opportunity
            <br className="hidden md:block" /> could be closer than you think
          </h2>
          <GoToQuizButton className="w-full md:w-auto" funnelId={funnelId} />
        </div>
      )}
      <div className="w-full max-w-[1440px] mx-auto flex flex-col gap-6 px-4 py-6 md:px-10 md:py-10">
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-6">
          <Logo />
          <div className="flex flex-col md:flex-row gap-4 md:gap-6">
            <a href="/privacy-policy" className="font-semibold hover:underline">
              Privacy Policy
            </a>
            <a href="/terms-and-conditions" className="font-semibold hover:underline">
              Terms & Conditions
            </a>
            <a href="/contact-us" className="font-semibold hover:underline">
              Contact Us
            </a>
          </div>
        </div>
        <div className="w-full h-px bg-[#DFDFDF]" />
        <div className="flex flex-col md:flex-row md:justify-between md:items-center gap-4">
          <div className="flex items-center gap-2">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
              <path
                d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"
                stroke="#333"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
              <path d="M22 6l-10 7L2 6" stroke="#333" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
            <a
              href={`mailto:${brandSupportEmail}`}
              className="text-[14px] font-normal leading-[1.43em] text-[#333] hover:underline"
            >
              {brandSupportEmail}
            </a>
          </div>
        </div>
        <div className="w-full h-px bg-[#DFDFDF] md:hidden" />
        <span className="text-[12px] font-normal leading-[1em] md:leading-[1.5em] text-[#535353]">
          © {new Date().getFullYear()} {brandName}. All rights reserved.
        </span>
      </div>
    </footer>
  );
};

export default FooterSection;
